module.exports = __webpack_public_path__ + "static/media/female.a30122df.png";